module.exports = __webpack_public_path__ + "img/burger_menu_white.167a06ef.svg";